import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setHiddenSidebar } from "../../../../store/app";

import TakeSurvey from "../../../surveys/take/Form";

import {
  Container,
  Stack,
  ScrollArea,
  Box,
  Title,
  createStyles,
} from "@mantine/core";

import { useTranslation } from "react-i18next";

const useStyles = createStyles((theme, { colors }, getRef) => ({
  spaceContainer: {
    backgroundColor: colors.background_color,
    color: colors.default_text_color,
  },
}));

export default function Survey(props) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const colors = useSelector(state => state.colors);
  const space = useSelector(state => state.space);
  const survey = useSelector(state => state.survey);

  const { classes, cx, theme } = useStyles({ colors });

  useEffect(() => {
    const b = document.getElementsByTagName("body")[0];
    // debugger;
    b.style.display = "none";

    dispatch(setHiddenSidebar({ hidden: true }));

    setTimeout(() => {
      const b = document.getElementsByTagName("body")[0];
      b.style.display = "";
      dispatch(setHiddenSidebar({ hidden: true }));
    }, 500);

    return () => {
      dispatch(setHiddenSidebar({ hidden: false }));
    };
  }, []);

  const onTaken = () => {
    navigate(`/space/${props.space.slug}?refresh=true`);
  };

  return (
    <Stack
      className={classes.spaceContainer}
      spacing={0}
      style={{ height: "100%" }}
    >
      <ScrollArea className="content-scrollview" style={{ height: "100%" }}>


        <Container
          sx={(theme) => ({
            height: "100%",
            maxWidth: 600
          })}>
          {survey && survey.id && (
            <Box
              p={20}
              pt={40}
            >
              <Box
                sx={(theme) => ({
                  border: `1px solid ${colors.default_text_color}`,
                  borderRadius: 10,
                  paddingTop: 30,
                  paddingBottom: 40,
                  paddingLeft: 40,
                  paddingRight: 40,
                  marginBottom: 40,
                })}
              >
                <Title
                  sx={(theme) => ({
                    marginBottom: 10,
                    fontSize: 24,
                    fontWeight: 900 })}
                  >
                  {space.name}
                </Title>
                <TakeSurvey
                  survey={survey}
                  onTaken={onTaken} />
              </Box>
            </Box>
          )}
        </Container>
      </ScrollArea>
    </Stack>
  );
}
